import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { ConnectedProjectDto } from "@/api/types";
import { useSelfAccountQueries } from "@/queries/self-account/queryOptions";

// TODO: replace this hook's usage with `useSelfAccountQueries().listLinkedProjects()`
// Get list of projects the auth user is linked to
export function useLinkedProjects({ isEnabled } = { isEnabled: true }): UseQueryResult<ConnectedProjectDto[]> {
  const selfAccountQueries = useSelfAccountQueries();

  return useQuery({
    ...selfAccountQueries.listLinkedProjects(),
    enabled: isEnabled,
  });
}
